import {Request} from '@/apis'

export function page(params) {
    return Request.get("/user/page", params);
}

export function info() {
    return Request.get("/user/info");
}

export function getObj(id) {
    return Request.get("/user/" + id);
}

export function saveObj(obj) {
    return Request.post("/user", obj);
}

export function updateObj(obj) {
    return Request.put("/user", obj);
}

export function deleteObj(id) {
    return Request.delete("/user/" + id);
}

export function updateLoginPassword(obj) {
    return Request.put("/user/updateLoginPassword", obj);
}

export function modifyPassword(obj) {
    return Request.put("/user/modifyPassword", obj);
}

export function uploadData(file) {
    let form = new FormData();
    form.append("file", file);
    return Request.upload("/user/upload", form);
}

export function downloadModel() {
    return Request.download("/user/downloadModel", {});
}

export function exportData(params) {
    return Request.export("/user/export", params);
}
